import { render, staticRenderFns } from "./OrgUpdate.vue?vue&type=template&id=500d1a28&"
import script from "./OrgUpdate.vue?vue&type=script&lang=js&"
export * from "./OrgUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports